import { useMemo } from 'react';
import { useSubscriptionHistory } from 'reactQuery/queries';

const useFlattenedSubscriptionHistory = (
  subscriptionHistory: ReturnType<typeof useSubscriptionHistory> | undefined
) => {
  return useMemo(
    () => subscriptionHistory?.data?.pages[0]?.subscriptions?.flat() || [],
    [subscriptionHistory?.data?.pages]
  );
};

export default useFlattenedSubscriptionHistory;
